import { BalloonToolbarOnExpanded } from './balloon-toolbar-on-expanded/BalloonToolbarOnExpanded';
import { BalloonToolbarOnCollapsed } from './balloon-toolbar-on-collapsed/BalloonToolbarOnCollapsed';
import { BalloonToolbarAtEdgeBlock } from './balloon-toolbar-at-edge-block/BalloonToolbarAtEdgeBlock';

export const DolBalloonToolbar = {
  OnExpanded: BalloonToolbarOnExpanded,
  OnCollapsed: BalloonToolbarOnCollapsed,
  AtEdgeBlock: BalloonToolbarAtEdgeBlock,
};
